import { useAuthContext } from '../auth/context';

export function useFeatureFlags() {
  return useAuthContext().currentUser.flags || [];
}
